const AppConfigReducerInitialState = {
  search_page_url: (process.env.REACT_APP_SEARCH_PAGE_URL ?? ''),
  current_language: (process.env.REACT_APP_DEFAULT_LANG ?? ''),
  auto_suggest_api_base_url: (process.env.REACT_APP_AUTO_SUGGEST_API_BASE_URL ?? '')
};

export default AppConfigReducerInitialState;
